import React, {useState} from 'react';
import * as S from './SrpCardLoader.styles';
import LineLoader from '../../../../../../stories/core-components/LineLoader/LineLoader';

const SrpCardLoader = () => {
  return (
    <S.ActivecardLayoutDiv>
      <S.ActivepcardInnerLayoutDiv>
        <S.LoaderWrap>
          <S.ImageWrapDiv>
            <S.ImageWrap>
              <LineLoader width="7.2rem" height="7.2rem"></LineLoader>
            </S.ImageWrap>
            <div>
              <LineLoader width="10rem"></LineLoader>
              <LineLoader width="16.7rem"></LineLoader>
            </div>
          </S.ImageWrapDiv>

          <S.TextWrapDiv>
            <LineLoader width="10rem"></LineLoader>
            <LineLoader width="16.7rem"></LineLoader>
          </S.TextWrapDiv>

          <S.ButtonWrap>
            <LineLoader width="10rem"></LineLoader>
            <LineLoader width="13rem" height="3.3rem"></LineLoader>
          </S.ButtonWrap>
        </S.LoaderWrap>
      </S.ActivepcardInnerLayoutDiv>
      <S.AmminitiesLayoutDiv>
        <S.AmminitiesInnerLayoutDiv>
          <LineLoader width="11.5rem"></LineLoader>
          <div>&nbsp;&nbsp;</div>
          <LineLoader width="11.5rem"></LineLoader>
        </S.AmminitiesInnerLayoutDiv>
      </S.AmminitiesLayoutDiv>
    </S.ActivecardLayoutDiv>
  );
};

export default SrpCardLoader;
